import { FormattedMessage } from 'react-intl';

import { DebitCardCompletedView } from './DebitCardCompletedView';
import {
    RequirementItem,
    TFundingRequirementStatus
} from '../RequirementsList/RequirementItem/RequirementItem';

type TDebitCardStepProps = {
    status: TFundingRequirementStatus;
};

export const DebitCardStep = ({ status }: TDebitCardStepProps) => {
    return (
        <RequirementItem
            title={
                <FormattedMessage
                    id="_.funding_requirements.debit_card_step.list_title"
                    defaultMessage="Add your debit card for repayments"
                />
            }
            estimatedTime={
                <FormattedMessage
                    id="_.funding_requirements.debit_card_step.estimated_time"
                    defaultMessage="~ 1 min"
                />
            }
            href="/funding-requirements/debit-card"
            status={status}
            completedView={<DebitCardCompletedView />}
        />
    );
};
